import { Grid } from "@mui/material";
import DatePickerField from "../../../../components/Dashboard/DatePickerField";
import { useIntl } from "../../../../contexts/IntlContext";

type Props = {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
};

/** Data de início/fim do período. `error` (quando informado) aparece como helperText do campo de fim. */
export default function PeriodRangeFields({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled,
  error,
}: Props) {
  const intl = useIntl();
  return (
    <>
      <Grid item xs={12} md={6}>
        <DatePickerField
          label={intl.formatMessage({ id: "liveStreams.period.startDate" })}
          value={startDate}
          onChange={onStartDateChange}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePickerField
          label={intl.formatMessage({ id: "liveStreams.period.endDate" })}
          value={endDate}
          onChange={onEndDateChange}
          disabled={disabled}
          error={Boolean(error)}
          helperText={error}
          fullWidth
        />
      </Grid>
    </>
  );
}
